import { Dispatch } from 'redux';
import { OrderedMap } from 'immutable';
import { Moment } from 'moment';

import { fetcher } from '../../lib/request';

import { Category } from '../../models/Afisha/Category';
import Genre from '../../models/Afisha/Genre';

const AFISHA_HOST = process.env.REACT_APP_AFISHA_HOST;
const AFISHA_KEY = process.env.REACT_APP_AFISHA_KEY;

export const GET_FILTERS_REQUEST = 'AFISHA_GET_FILTERS_REQUEST';
export const GET_FILTERS_RESPONSE = 'AFISHA_GET_FILTERS_RESPONSE';
export const GET_FILTERS_ERROR = 'AFISHA_GET_FILTERS_ERROR';

export const RESET_FILTERS = 'AFISHA_RESET_FILTERS';

export const SET_ORDER = 'AFISHA_SET_ORDER';
export const SET_AGE = 'AFISHA_SET_AGE';
export const SET_GENRES = 'AFISHA_SET_GENRES';
export const SET_CATEGORIES = 'AFISHA_SET_CATEGORIES';

interface FiltersResponse {
    result: {
        age_restrictions: number[];
        genres: Genre[];
    };
}

export const getFiltersAction = (
    city: number,
    compilation: string,
    type: string,
    dateFrom: Moment,
    dateTo: Moment | null = null,
    lang: string
) => async (dispatch: Dispatch<any>) => {
    dispatch({
        type: GET_FILTERS_REQUEST
    });

    try {
        if (!lang) {
            lang = 'ru';
        }

        const dates = `&date_from=${dateFrom.format('YYYY-MM-DD HH:mm:ss')}${dateTo ? `&date_to=${dateTo.format('YYYY-MM-DD HH:mm:ss')}` : ''}`;

        const response = await fetcher<FiltersResponse>(`${AFISHA_HOST}/api/v3/${type}/compilations/${compilation}/filter?` +
            `city_id=${city}${dates}&lang=${lang}`)
            .auth(`Basic ${AFISHA_KEY}`)
            .json();

        dispatch({
            type: GET_FILTERS_RESPONSE,
            response,
            typeFilters: type
        });
    } catch (error) {
        dispatch({
            type: GET_FILTERS_ERROR,
            error: error
        });
    }
};

export const resetFiltersAction = () => (dispatch: Dispatch<any>) => {
    dispatch({
        type: RESET_FILTERS
    });
};

export const setOrderAction = (order: string) => (dispatch: Dispatch<any>) => {
    dispatch({
        type: SET_ORDER,
        order
    });
};

export const setAgeRestrictionAction = (ageRestriction: number | null) => (dispatch: Dispatch<any>) => {
    dispatch({
        type: SET_AGE,
        ageRestriction
    });
};

export const setGenresAction = (genres: OrderedMap<number, Genre>) => (dispatch: Dispatch<any>) => {
    dispatch({
        type: SET_GENRES,
        genres
    });
};

export const setCategoriesAction = (categories: OrderedMap<string, Category>) => (dispatch: Dispatch<any>) => {
    dispatch({
        type: SET_CATEGORIES,
        categories
    });
};



// WEBPACK FOOTER //
// ./src/actions/Afisha/filters.ts